import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {z} from "zod"

export const LabChannelStats = z.object({
    mean: z.number(),
    stddev: z.number().min(0),
})

export const definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            sourceImage: anyImageOpResult,
            // only supplied for interactive preview (see OperatorRecolor.createImageOpGraph); otherwise the node computes it live
            sourceStats: z
                .object({
                    l: LabChannelStats,
                    a: LabChannelStats,
                    b: LabChannelStats,
                })
                .optional(),
            targetStats: z.object({
                l: LabChannelStats,
                a: LabChannelStats,
                b: LabChannelStats,
            }),
            luminance: z.number().min(0).max(1).optional().default(1),
            colorIntensity: z.number().min(0).max(1).optional().default(1),
            fade: z.number().min(0).max(1).optional().default(1),
        }),
    },
}
